import { parseTime, type Time } from "@internationalized/date";
import * as Sentry from "@sentry/react";
import dayjs from "dayjs";

/** `parseTime` throws on a malformed value, which would take the page down; report it and treat it as empty. */
export function safeParseTime(value: string, source: string): Time | null {
  if (!value) return null;
  try {
    return parseTime(value);
  } catch (error) {
    Sentry.captureException(error, {
      extra: { source, value },
    });
    return null;
  }
}

/** A selected calendar slot is an ISO datetime string or null; format just its time, returning null (not the literal `"Invalid Date"`) when nothing valid is selected, so callers never persist that string. */
export function formatSelectedTime(value: dayjs.ConfigType): string | null {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("HH:mm") : null;
}

export function convertMinutesToHHmm(minutes: number) {
  // Calculate total hours and remaining minutes
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  // Format hours and minutes to ensure two digits
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(remainingMinutes).padStart(2, "0");

  // Return the formatted time
  return `${formattedHours}:${formattedMinutes}`;
}
